import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LoginService } from './login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../domain/users/user.model';
import { SnackBarService } from '../../services/snackbar.service';
import { GlobalSpinnerService } from '../../components/loader-service/global-spinner.service';
import { Principal } from '../principal.service';
import { AuthService } from '../auth.service';
import { UserUtils } from '../../domain/users/user-utils.model';

@Component({
  selector: 'cm-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild('username', { static: false }) vc: ElementRef;

  user: User = new User();
  registerLinkVisible = false;
  termsAndConditions = false;
  private returnUrl: any | string;

  constructor(private loginService: LoginService,
              private router: Router,
              private route: ActivatedRoute,
              private authService: AuthService,
              private principal: Principal,
              private snackBarService: SnackBarService,
              private globalSpinnerService: GlobalSpinnerService) {
  }

  ngOnInit() {
    this.loginService.logout();
    this.route.queryParams.subscribe(next => {
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || null;
    });
  }

  public login() {
    this.globalSpinnerService.showLoader();
    this.loginService.login(this.user)
      .then((user: User) => {
        if (UserUtils.isPublisher(user)) {
          this.authService.publisherIdentity(true).subscribe(next => {
            if (this.principal.publisher.selfServed && !this.principal.publisher.ssIntroCompleted) {
              this.navigate(['/welcome']);
            } else {
              this.navigate(['/dashboard']);
            }
          });
        } else if (UserUtils.isDemandPartner(user)) {
          this.authService.demandPartnerIdentity(true).subscribe(next => {
            this.navigate(['/dashboard']);
          });
        } else if (UserUtils.isKitchenUser(user)) {
          this.navigate(['/dashboard']);
        }
        this.globalSpinnerService.hideLoader();
      }).catch((error) => {
      console.error(error);
      this.globalSpinnerService.hideLoader();
      this.snackBarService.open('Invalid credentials');
    });
  }

  private navigate(location) {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
    } else {
      this.router.navigate(location);
    }
  }

}
